import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { jobAPI } from '../../../api'
import {
  JOB_APPLICATION_SUBMIT_REQUEST,
  JOB_APPLICATION_SUBMIT_SUCCESS,
  JOB_APPLICATION_SUBMIT_FAILED,
} from './actionTypes'

export const jobApplicationSubmitPA = createPromiseAction(
  JOB_APPLICATION_SUBMIT_REQUEST,
  JOB_APPLICATION_SUBMIT_SUCCESS,
  JOB_APPLICATION_SUBMIT_FAILED
)()

function* submit(action) {
  try {
    const { id, params } = action.payload

    const response = yield call(jobAPI.createApplication, id, params)

    const { data } = response

    yield put(jobApplicationSubmitPA.success({}))

    resolvePromiseAction(action, { ...data })
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* submitSaga() {
  yield takeEvery(jobApplicationSubmitPA.request, submit)
}
